import { render, staticRenderFns } from "./AccountTeams.vue?vue&type=template&id=7987ca40&"
import script from "./AccountTeams.vue?vue&type=script&lang=js&"
export * from "./AccountTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7987ca40')) {
      api.createRecord('7987ca40', component.options)
    } else {
      api.reload('7987ca40', component.options)
    }
    module.hot.accept("./AccountTeams.vue?vue&type=template&id=7987ca40&", function () {
      api.rerender('7987ca40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/AccountTeams.vue"
export default component.exports